import React from "react";
import { Controller, useWatch } from "react-hook-form";
import { 
  TextField, 
  Checkbox, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from "@mui/material";

import NumberFormat from "react-number-format";

const defaultRows = [
  { id: 1, description: "Folha de Pagamento" },
  { id: 2, description: "Adiantamento" },
  { id: 3, description: "Vale Refeição" },
  { id: 4, description: "Vale Alimentação" },
  { id: 5, description: "Cesta Básica" },
  { id: 6, description: "Vale Transporte" },
  { id: 7, description: "13º Salário - 1ª Parcela" },
  { id: 8, description: "13º Salário - 2ª Parcela" },
  { id: 9, description: "Folha de PLR" },
];

const DayFormatCustom = React.forwardRef(function DayFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isAllowed={({ value, floatValue }) => {
        if (!value) return true;
        return floatValue >= 1 && floatValue <= 31;
      }}
      allowNegative={false}
      decimalScale={0}
      isNumericString
    />
  );
});

const Row = ({ row, control }) => {
  const isNotApplicable = useWatch({
    control,
    name: `notApplicable-${row.id}`,
    defaultValue: false,
  });

  return (
    <TableRow>
      <TableCell>{row.description}</TableCell>
      <TableCell>
        <Controller
          name={`notApplicable-${row.id}`}
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={!!field.value}
              inputProps={{ "aria-label": "Não se aplica" }}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
      </TableCell>
      <TableCell>
        {!isNotApplicable && (
          <Controller
            name={`paymentDay-${row.id}`}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Dia"
                size="small"
                variant="outlined"
                required={!isNotApplicable}
                error={!!error}
                helperText={error?.message}
                InputProps={{ 
                  inputComponent: DayFormatCustom 
                }}
                style={{ width: 180 }}
              />
            )}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

const CalendarGridTable = ({ control, initialData, isDisabled = false }) => {
  const rows = initialData?.length > 0 ? initialData : defaultRows;

  return (
    <div style={{ width: "100%" }}>
      <TableContainer component={Paper} elevation={0} variant="outlined" style={{ pointerEvents: isDisabled ? "none" : "auto", opacity: isDisabled ? 0.6 : 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Descrição</TableCell>
              <TableCell>Não se aplica</TableCell>
              <TableCell>Dia de pagamento</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <Row key={row.id} row={row} control={control} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CalendarGridTable;
